export default function AccionesPedido({
  puedeAgregar,
  labelPrincipal,
  onAgregar,
  onVolver,
  onCarrito,
}) {
  return (
    <div className="space-y-3">
      <button
        disabled={!puedeAgregar}
        onClick={onAgregar}
        className={`w-full py-3 rounded-xl font-bold transition ${
          puedeAgregar
            ? "bg-orange-500 text-black hover:bg-orange-400"
            : "bg-gray-600 text-gray-300 cursor-not-allowed"
        }`}
      >
        {labelPrincipal}
      </button>

      <button
        onClick={onVolver}
        className="w-full bg-gray-700 py-2 rounded hover:bg-gray-600 transition"
      >
        ⬅️ Seguir eligiendo
      </button>

      <button
        onClick={onCarrito}
        className="w-full bg-green-500 text-black py-3 rounded-xl font-bold hover:bg-green-400 transition"
      >
        🛒 Ir al carrito
      </button>
    </div>
  );
}
